/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  JobListItemDto,
  UserDetailsShortDto,
} from '@gh/builder-shared-data';

export enum JobElementType { Normal, Total = 'jobListItemTotals' }
export type JobElementTotal = {
  type: JobElementType.Total;
  [key: string]: any;
};
export type JobElementOrTotal = JobListItem | JobElementTotal;
export function isJobElementTotal(element: JobElementOrTotal): element is JobElementTotal {
  return element['type'] && element['type'] === JobElementType.Total;
}

export type JobListItem = JobListItemDto;
export type JobSalesPerson = UserDetailsShortDto;
export type JobAdmin = UserDetailsShortDto;
